export default __webpack_public_path__ + "static/media/contactUs-banner.e496eb5c.jpg";